import { type Theme, useTheme } from '@mui/material/styles';
import createCriteriaTheme from './createCriteriaTheme';
const useCriteriaTheme = (): Theme => {
  const otaTheme = useTheme();
  const materialUiTheme = createCriteriaTheme(otaTheme);
  return materialUiTheme;
};
export default useCriteriaTheme;